<template>
    <div class="card p-2" v-loading="awsInfo.isLoading">
        <div>
            <div class="d-md-flex align-items-center">
                <div class="flex-fill mb-2 mb-md-0">
                    <div class="d-flex align-items-center">
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" version="2.0" focusable="false" aria-hidden="true" 
                                 class="globalNav-0311 globalNav-038" viewBox="0 0 29 17" style="width: 3.3rem;">
                                <path class="globalNav-039" d="M8.38 6.17a2.6 2.6 0 00.11.83c.08.232.18.456.3.67a.4.4 0 01.07.21.36.36 0 01-.18.28l-.59.39a.43.43 0 01-.24.08.38.38 0 01-.28-.13 2.38 2.38 0 01-.34-.43c-.09-.16-.18-.34-.28-.55a3.44 3.44 0 01-2.74 1.29 2.54 2.54 0 01-1.86-.67 2.36 2.36 0 01-.68-1.79 2.43 2.43 0 01.84-1.92 3.43 3.43 0 012.29-.72 6.75 6.75 0 011 .07c.35.05.7.12 1.07.2V3.3a2.06 2.06 0 00-.44-1.49 2.12 2.12 0 00-1.52-.43 4.4 4.4 0 00-1 .12 6.85 6.85 0 00-1 .32l-.33.12h-.14c-.14 0-.2-.1-.2-.29v-.46A.62.62 0 012.3.87a.78.78 0 01.27-.2A6 6 0 013.74.25 5.7 5.7 0 015.19.07a3.37 3.37 0 012.44.76 3 3 0 01.77 2.29l-.02 3.05zM4.6 7.59a3 3 0 001-.17 2 2 0 00.88-.6 1.36 1.36 0 00.32-.59 3.18 3.18 0 00.09-.81V5A7.52 7.52 0 006 4.87h-.88a2.13 2.13 0 00-1.38.37 1.3 1.3 0 00-.46 1.08 1.3 1.3 0 00.34 1c.278.216.63.313.98.27zm7.49 1a.56.56 0 01-.36-.09.73.73 0 01-.2-.37L9.35.93a1.39 1.39 0 01-.08-.38c0-.15.07-.23.22-.23h.92a.56.56 0 01.36.09.74.74 0 01.19.37L12.53 7 14 .79a.61.61 0 01.18-.37.59.59 0 01.37-.09h.75a.62.62 0 01.38.09.74.74 0 01.18.37L17.31 7 18.92.76a.74.74 0 01.19-.37.56.56 0 01.36-.09h.87a.21.21 0 01.23.23 1 1 0 010 .15s0 .13-.06.23l-2.26 7.2a.74.74 0 01-.19.37.6.6 0 01-.36.09h-.8a.53.53 0 01-.37-.1.64.64 0 01-.18-.37l-1.45-6-1.44 6a.64.64 0 01-.18.37.55.55 0 01-.37.1l-.82.02zm12 .24a6.29 6.29 0 01-1.44-.16 4.21 4.21 0 01-1.07-.37.69.69 0 01-.29-.26.66.66 0 01-.06-.27V7.3c0-.19.07-.29.21-.29a.57.57 0 01.18 0l.23.1c.32.143.656.25 1 .32.365.08.737.12 1.11.12a2.47 2.47 0 001.36-.31 1 1 0 00.48-.88.88.88 0 00-.25-.65 2.29 2.29 0 00-.94-.49l-1.35-.43a2.83 2.83 0 01-1.49-.94 2.24 2.24 0 01-.47-1.36 2 2 0 01.25-1c.167-.3.395-.563.67-.77a3 3 0 011-.48A4.1 4.1 0 0124.4.08a4.4 4.4 0 01.62 0l.61.1.53.15.39.16c.105.062.2.14.28.23a.57.57 0 01.08.31v.44c0 .2-.07.3-.21.3a.92.92 0 01-.36-.12 4.35 4.35 0 00-1.8-.36 2.51 2.51 0 00-1.24.26.92.92 0 00-.44.84c0 .249.1.488.28.66.295.236.635.41 1 .51l1.32.42a2.88 2.88 0 011.44.9 2.1 2.1 0 01.43 1.31 2.38 2.38 0 01-.24 1.08 2.34 2.34 0 01-.68.82 3 3 0 01-1 .53 4.59 4.59 0 01-1.35.22l.03-.01z"></path><path class="globalNav-0310" d="M25.82 13.43a20.07 20.07 0 01-11.35 3.47A20.54 20.54 0 01.61 11.62c-.29-.26 0-.62.32-.42a27.81 27.81 0 0013.86 3.68 27.54 27.54 0 0010.58-2.16c.52-.22.96.34.45.71z"></path><path class="globalNav-0310" d="M27.1 12c-.4-.51-2.6-.24-3.59-.12-.3 0-.34-.23-.07-.42 1.75-1.23 4.63-.88 5-.46.37.42-.09 3.3-1.74 4.68-.25.21-.49.09-.38-.18.34-.95 1.17-3.02.78-3.5z"></path>
                            </svg>
                        </div>
                        <div class="ml-3">
                            <h5 class="mt-0 mb-0">
                                <strong class=" text-primary">S3 Transfer Cost</strong>
                            </h5>
                            <div>
                                Total <strong class="text-danger">{{totalUsd | numFormat('0,0[.][00]')}} USD</strong>, 
                                Transfer <strong class="text-success">{{totalUsageQuantityOut | numFormat('0,0[.][00]')}} GB</strong>,
                                Storage <strong>{{totalUsageQuantityStorage | numFormat('0,0[.][00]')}} GB | ${{totalCostStorage | numFormat('0,0[.][00]')}}</strong>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mr-md-3 mb-2 mb-md-0">
                    <el-radio-group v-model="awsInfo.requestParams.granularity" size="small"
                                    @change="setGranularity">
                        <el-radio-button label="daily" class="m-0">
                            <strong>Daily</strong>
                        </el-radio-button>
                        <!--<el-radio-button label="hourly" class="m-0">
                            <strong>Hourly</strong>
                        </el-radio-button>-->
                        <el-radio-button label="monthly" class="m-0">
                            <strong>Monthly</strong>
                        </el-radio-button>
                    </el-radio-group>
                </div>
                <div class="mr-md-3 mb-2 mb-md-0">
                    <el-date-picker v-model="awsInfo.requestParams.dateRange"
                                    size="small"
                                    :format="$elDatePickerFormat" type="daterange"
                                    @change="debounceFnc"
                                    value-format="yyyy-MM-dd"
                                    range-separator="To"
                                    start-placeholder="Start date"
                                    end-placeholder="End date">
                    </el-date-picker>
                </div>
                <div class="mb-3 mb-md-0">
                    <button class="btn btn-sm btn-primary" @click="getAwsInfo">
                        <i class="fas fa-sync-alt mr-2"></i> Refresh
                    </button>
                    <button class="btn btn-sm btn-primary ml-1" @click="reset">
                        Reset
                    </button>
                    <button class="btn btn-sm btn-primary ml-1" @click="thisMonth">
                        This month
                    </button>
                    <button class="btn btn-sm btn-primary ml-1" @click="lastMonth">
                        Last month
                    </button>
                </div>
            </div>
            <div class="mt-3">
                <highcharts :options="awsInfo.options"></highcharts>
            </div>
            <!--<div class="container-fluid mb-1">
                <div class="row">
                    <div :key="element.dateStamp"
                            v-for="element in awsInfo.tableData"
                            class="col-4 col-md-2 m-0 p-1">
                        <div class="card p-2 mb-0">
                            <div class="text-left text-nowrap p-1 pr-3" style="line-height: 0.8rem;">
                                <span class="mb-0">
                                    <i class="fas fa-calendar-alt text-primary"></i> <strong>{{element.dateStamp}}</strong>
                                </span>
                            </div>
                            <div class="text-left d-flex align-items-center p-1" style="line-height: 0.8rem;">
                                <span class="mb-0 mt-0 flex-fill">
                                    <strong class="text-navy text-nowrap mr-2 d-inline-block" style="width: 2rem;">Total</strong> 
                                </span>
                                <span class="mb-0">
                                    &nbsp;<i class="fas fa-dollar-sign"></i> 
                                    {{(element.metricsCost !== null ? element.metricsCost.BlendedCost.amount : 0) | numFormat('0,0[.][00]')}}
                                </span>
                            </div>-->
                            <!--<div class="text-left p-1">
                                <h5 class="mb-0 mt-0" style="line-height: 0.5rem;">
                                    <strong class="text-success text-nowrap mr-2 d-inline-block" style="width:2rem;">In</strong>
                                    <small>{{(element.metricsUsageQuantityIn != null ? element.metricsUsageQuantityIn.UsageQuantity.amount : 0) | numFormat('0,0[.][00]')}} GB</small>
                                </h5>
                            </div>-->
                            <!--<div class="text-left d-flex align-items-center p-1" style="line-height: 0.8rem;">
                                <span class="mb-0 mt-0 flex-fill">
                                    <strong class="text-navy text-nowrap mr-2 d-inline-block" style="width: 2rem;">Out</strong> 
                                </span>
                                <span>{{(element.metricsUsageQuantityOut !== null ? element.metricsUsageQuantityOut.UsageQuantity.amount : 0) | numFormat('0,0[.][00]')}} GB</span>
                            </div> 
                            <div class="text-left d-flex align-items-center p-1" style="line-height: 0.8rem;">
                                <span class="mb-0 mt-0 flex-fill">
                                    <strong class="text-navy text-nowrap mr-2 d-inline-block" style="width: 2rem;">Storage</strong>
                                </span>
                                <span>{{(element.dataStorageUsage !== null ? element.dataStorageUsage.UsageQuantity.amount : 0) | numFormat('0,0[.][00]')}} GB</span>
                            </div> 
                        </div>
                    </div>
                </div>
            </div>-->     
        </div>
    </div>
</template>

<script>
    import commonAct from '@/commonActionHandle.js';
    import awsRequestApi from '@/api/common/awsRequestApi';
    import { Chart } from 'highcharts-vue';
    import Highcharts from 'highcharts'
    import { areaSplineChart, colorSun, colorSat, colorNormal } from "@/constant/dashboardChartOptions";
    import moment from "moment";
    import { debounce } from 'vue-debounce';
    var momentDurationFormatSetup = require("moment-duration-format");
    momentDurationFormatSetup(moment);
    export default {
        components: {
            highcharts: Chart
        },
        data() {
            return {
                debounceFnc: null,
                awsInfo: {
                    isLoading : false,
                    requestParams: {
                        granularity: "daily",
                        dateRange: [],
                    },
                    options: Object.assign(JSON.parse(JSON.stringify(areaSplineChart)), {
                    chart: {
                        height: 550,
                        type: 'areaspline'
                    },
                    yAxis: [{ // Primary yAxis
                            labels: {
                                format: '${value}',
                                style: {
                                    color: Highcharts.getOptions().colors[1]
                                }
                            },
                            title: {
                                text: 'Cost',
                                style: {
                                    color: Highcharts.getOptions().colors[1],
                                    "font-size": 15,
                                }
                            }
                        },
                        { // Secondary yAxis
                            title: {
                                text: 'Usage Quantity (GB)',
                                style: {
                                    "font-size": 15,
                                }
                            },
                            labels: {
                                format: '{value} GB',
                            },
                            opposite: true
                    }],
                    tooltip: {
                        shared: true
                    },
                    plotOptions: {
                        areaspline: {
                            dataLabels: {
                                enabled: true
                            },
                            fillOpacity: 0.5
                        }
                    },
                }),
                    tableData: [],
                },
            };
        },
        computed: {
            totalUsd() {
                return this.awsInfo.tableData.reduce((total, num) => {
                    return total + (num.metricsCost !== null ?parseFloat(num.metricsCost.BlendedCost.amount) : 0);
                }, 0);
            },
            //totalUsageQuantityIn() {
            //    return this.awsInfo.tableData.reduce((total, num) => {
            //        return total + (num.metricsUsageQuantityIn !== null ? parseFloat(num.metricsUsageQuantityIn.UsageQuantity.amount) : 0);
            //    }, 0);
            //},
            totalUsageQuantityOut() {
                return this.awsInfo.tableData.reduce((total, num) => {
                    return total + (num.metricsUsageQuantityOut !== null ? parseFloat(num.metricsUsageQuantityOut.UsageQuantity.amount) : 0);
                }, 0);
            },
            totalUsageQuantityStorage() {
                return this.awsInfo.tableData.reduce((total, num) => {
                    return total + (num.dataStorageUsage !== null ? parseFloat(num.dataStorageUsage.UsageQuantity.amount) : 0);
                }, 0);
            },
            totalCostStorage() {
                return this.awsInfo.tableData.reduce((total, num) => {
                    return total + (num.dataStorageUsage !== null ? parseFloat(num.dataStorageUsage.BlendedCost.amount) : 0);
                }, 0);
            }
        },
        created() {
            this.awsInfo.requestParams.dateRange = [moment().startOf('month').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
            this.getAwsInfo();
            this.debounceFnc = debounce(() => {
                this.getAwsInfo();
            }, 300);
        },
        methods: {
            getAwsInfo() {
                this.awsInfo.isLoading = true;
                awsRequestApi.getCostDailyAsync(this.awsInfo.requestParams).then(response => {
                    if (response.data && response.data.result === 0 && response.data.data !== null) {
                        let dateFormat = 'DD-MM-YYYY';
                        if (this.awsInfo.requestParams.granularity === 'monthly') dateFormat = 'MM-YYYY';
                        this.awsInfo.tableData = response.data.data;
                        this.awsInfo.options.xAxis.categories = [];
                        this.awsInfo.options.xAxis.categories = response.data.data.map(x => moment(x.dateStamp).format(dateFormat));
                        this.awsInfo.options.series = [
                            {
                                name: "Cost ($)",
                                type: 'column',
                                dataLabels: {
                                    enabled: true,
                                    format: '${y}'
                                },
                                tooltip: {
                                    valuePrefix: '$'
                                },
                                color: '#4897C9',
                                data: response.data.data.map(x => {
                                    return {
                                        y: x.metricsCost != null ? (Math.round((parseFloat(x.metricsCost.BlendedCost.amount) + Number.EPSILON) * 100) / 100) : 0,
                                        marker: {
                                            fillColor: (moment.utc(x.dateStamp).day() === 0) ? colorSun : ((moment.utc(x.dateStamp).day() === 6) ? colorSat : colorNormal)
                                        }
                                    }
                                })
                            },
                            {
                                name: "S3: Storage Cost ($)",
                                type: 'column',
                                dataLabels: {
                                    enabled: true,
                                    format: '${y}'
                                },
                                tooltip: {
                                    valuePrefix: '$'
                                },
                                color: '#2f5f53',
                                data: response.data.data.filter(xItem => xItem.dataStorageUsage !== null).map(x => {
                                    return {
                                        y: x.dataStorageUsage != null ? (Math.round((parseFloat(x.dataStorageUsage.BlendedCost.amount) + Number.EPSILON) * 100) / 100) : 0,
                                        marker: {
                                            fillColor: (moment.utc(x.dateStamp).day() === 0) ? colorSun : ((moment.utc(x.dateStamp).day() === 6) ? colorSat : colorNormal)
                                        }
                                    }
                                })
                            },
                            {
                                name: "S3: Transfer Cost ($)",
                                type: 'column',
                                dataLabels: {
                                    enabled: true,
                                    format: '${y}'
                                },
                                tooltip: {
                                    valuePrefix: '$'
                                },
                                color: '#B63AD7',
                                data: response.data.data.filter(xItem => xItem.metricsUsageQuantityOut !== null).map(x => {
                                    return {
                                        y: x.metricsUsageQuantityOut != null ? (Math.round((parseFloat(x.metricsUsageQuantityOut.BlendedCost.amount) + Number.EPSILON) * 100) / 100) : 0,
                                        marker: {
                                            fillColor: (moment.utc(x.dateStamp).day() === 0) ? colorSun : ((moment.utc(x.dateStamp).day() === 6) ? colorSat : colorNormal)
                                        }
                                    }
                                })
                            },
                            {
                                name: "S3: Data Transfer Usage (GB)",
                                type: 'spline',
                                yAxis: 1,
                                dataLabels: {
                                    enabled: true,
                                    format: '{y}GB'
                                },
                                tooltip: {
                                    valuePrefix: '',
                                    valueSuffix: 'GB'
                                },
                                color: '#C52323',
                                lineWidth: 3,
                                data: response.data.data.map(x => {
                                    return {
                                        y: x.metricsUsageQuantityOut !== null ? (Math.round((parseFloat(x.metricsUsageQuantityOut.UsageQuantity.amount) + Number.EPSILON) * 100) / 100) : 0,
                                        marker: {
                                            fillColor: (moment.utc(x.dateStamp).day() === 0) ? colorSun : ((moment.utc(x.dateStamp).day() === 6) ? colorSat : colorNormal)
                                        }
                                    }
                                })
                            },
                            //{
                            //    name: "S3: Data Transfer In (GB)",
                            //    type: 'spline',
                            //    yAxis: 1,
                            //    dataLabels: {
                            //        enabled: true,
                            //        format: '{y}GB'
                            //    },
                            //    tooltip: {
                            //        valuePrefix: '',
                            //        valueSuffix: 'GB'
                            //    },
                            //    color: '#F4C709',
                            //    lineWidth: 3,
                            //    data: response.data.data.map(x => {
                            //        return {
                            //            y: (x.metricsUsageQuantityIn !== null ? (Math.round((parseFloat(x.metricsUsageQuantityIn.UsageQuantity.amount) + Number.EPSILON) * 100) / 100) : 0),
                            //            marker: {
                            //                fillColor: (moment.utc(x.dateStamp).day() === 0) ? colorSun : ((moment.utc(x.dateStamp).day() === 6) ? colorSat : colorNormal)
                            //            }
                            //        }
                            //    })
                            //},
                            ];
                        this.awsInfo.isLoading = false;
                    }
                    else {
                        this.awsInfo.isLoading = false;
                        if (response.data && response.data.message !== null && response.data.message !== '') {
                            console.error(response.data.message || this.$lang.common.error);
                        }
                    }
                }).catch(error => {
                    this.awsInfo.isLoading = false;
                    console.error(error);
                });
            },
            setGranularity() {
                if (this.awsInfo.requestParams.granularity === "daily") {
                    this.awsInfo.requestParams.dateRange = [moment().startOf('month').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
                    this.debounceFnc();
                }
                else {
                    this.awsInfo.requestParams.dateRange = [moment().startOf('year').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
                    this.debounceFnc();
                }
            },
            reset() {
                this.awsInfo.requestParams.dateRange = [moment().startOf('month').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
                this.awsInfo.requestParams.granularity = "daily";
                this.getAwsInfo();
            },
            thisMonth() {
                this.awsInfo.requestParams.dateRange = [moment().startOf('month').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
                this.awsInfo.requestParams.granularity = "daily";
                this.getAwsInfo();
            },
            lastMonth() {
                this.awsInfo.requestParams.dateRange = [moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'), moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD')];
                this.awsInfo.requestParams.granularity = "daily";
                this.getAwsInfo();
            },
        }
    }
</script>

<style>
    .globalNav-039 {
        fill: #000;
        fill-rule: nonzero;
    }
    .globalNav-0310 {
        fill: #F8991D;
        fill-rule: evenodd;
    }
</style>